
import React from 'react'
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import MediaInfoComponent from '../../../../../../common/components/common/media-info.component';
import _ from 'lodash';



export default function HelpTopicBasicInfoComponent ({handleFormItemChange,helpTopics,mediaFiles,handleFormHelpTopicItemChange,changeImage,handleInnerFormChange, selectedHelpTopics}: any) {
  const libraryData = useSelector(selectListItems)

  return (
      <>
        {_.map(
                    selectedHelpTopics,
                    (selectedHelpTopic: any, index: any) => (
       <>
     <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
            label="Title"
            labelField="Title"
            onValueChange={(event: any, newValue: any) => {
              handleFormHelpTopicItemChange({
                value: event.target.value,
                field: 'Title',
                idx: index
              });
            }}
            type="text"
            value={selectedHelpTopic?.Title}
        />
      <InputContainer
     label="Parent Topic" 
                      labelField="Title"
                      list={helpTopics}
                      onValueChange={( event: any) => {
                        handleFormHelpTopicItemChange({
                          value: event.target.value,
                          field: 'ParentId',
                          idx: index
                        });
                      }}
                        optionName="Choose Parent Topic"
                      type="select"
                      valueField="Id"
                      value={selectedHelpTopic?.ParentId}
  />        
        <div className='col-span-full'>
        <InputContainer 
          label="Body"
          name="Body"
          onValueChange={(event: any) => {
            handleFormHelpTopicItemChange({
              value: event.target.value,
              field: 'Body',
              idx: index
            });
          }}
          type="rte"
          value={selectedHelpTopic?.Body}
      /></div>
     </div>
  }
    expandedPanel="BasicInfo"
    headerTitle="Basic Info"
/>
<AccordionContainer
    child={
          <div>
   <MediaInfoComponent
      changeImage={changeImage}
      fileTypes={libraryData?.result?.FileType}
      onFormItemChange={handleFormItemChange}
      mediaFiles={mediaFiles}
      />
</div>
  }
    expandedPanel="Help topic Media"
    headerTitle="Help Topic Media Info"
/>
</>
    )
  )}
</>
  )
}